import axios from "axios";
import url from "../constants";
import {LoginFormProps, LoginFormOTPProps} from "../Models/loginForm";
import api from "../Interceptors/Interceptor";


const signInService = async (auth: LoginFormProps) => {
    const response = await api.post(url + `v1/auth/sign-in`, auth);
    return response;
};

const signInOtpService = async (auth: LoginFormOTPProps) => {
    const response = await api.post(url + `v1/auth/sign-in/otp`, auth);
    return response
};


const qrCodeService = async () => {
    const response = await api.get(url + `v1/auth/qr-code`);
    return response
};

const forgotPasswordService = async (principal: string) => {
    const response = await api.post(url + `v1/auth/reset-password`, {"username": principal});
    return response
};

const resetPasswordService = async (uuid: string, password: string) => {
    const response = await api.post(url + `v1/auth/reset-password/${uuid}/reset`, {"password": password});
    return response
};

const resetPasswordRetrieveService = async (uuid: string) => {
    const response = await api.get(url + `v1/auth/reset-password/${uuid}`);
    return response
};

const signOutService = async (auth: LoginFormProps) => {
    const response = await api.post(url + `v1/auth/sign-out`, auth);
    return response
};


const refreshService = async (auth: LoginFormProps) => {
    const response = await api.post(url + `v1/auth/refresh-token`, auth);
    return response
};

export {
    signInService,
    signOutService,
    signInOtpService,
    qrCodeService,
    forgotPasswordService,
    resetPasswordRetrieveService,
    resetPasswordService,
    refreshService
}